<template>
  <div class="results-page-mobile min-h-[100vh]">
    <ResultsWrapperMobile />
  </div>
</template>

<script>
import ResultsWrapperMobile from '@/wrappers/mobile/ResultsWrapperMobile.vue';

export default {
  name: 'ResultsPageMobile',
  components: {
    ResultsWrapperMobile,
  },
};
</script>
